import axios from 'axios';
import BaseCrud from './baseCrud';
const crud = new BaseCrud('loan-shop');

export const state = () => ({ ...crud.state });

export const getters = {
    ...crud.getters
};

export const mutations = {
    ...crud.mutations
};

export const actions = {
    ...crud.actions,

    getProducts(
        vuexContext,
        {
            id,
            currentPage = 1,
            perPage = 10,
            search = '',
            sortBy = 'createdAt',
            descending = true,
            filters = null
        }
    ) {
        const params = {
            page: currentPage,
            perPage,
            q: search,
            sortBy,
            order: descending ? 'DESC' : 'ASC'
        };

        if (filters) {
            params.filters = JSON.stringify(filters);
        }

        return axios.$get(`/admin/loan-shops/${id}/products`, {
            params
        });
    },

    getTags(vuexContext, { id, currentPage = 1, perPage = 10 }) {
        const params = {
            page: currentPage,
            perPage
        };

        return axios.$get(`/admin/loan-shops/${id}/tags`, {
            params
        });
    }
};
